import { defineStore } from "pinia";
import { ref } from "vue";
import i18n from "@/lib/i18n";
import { showOkCancelDialog } from "@/lib/dialog";

export const usePageEditStore = defineStore("pageEdit", () => {
  const isModified = ref<boolean>(false);

  function setModified(value: boolean) {
    isModified.value = value;
  }

  async function confirmUnsavedChanges() {
    if (!isModified.value) {
      return true;
    }

    const confirmed = await showOkCancelDialog({
      content: i18n.t("common.unsavedChanges.message") as string,
      okButton: i18n.t("common.unsavedChanges.discardButton") as string,
      cancelButton: i18n.t("common.unsavedChanges.stayButton") as string,
    });

    if (confirmed) {
      setModified(false);
    }

    return confirmed;
  }

  return { isModified, setModified, confirmUnsavedChanges };
});
